import type { JSX } from 'react';

import { VictoryIcon } from '@change/ds-icons';

import { Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

import { usePetitionDetailsPageData } from 'src/app/pages/petitionDetails/pageContext';

import { ShareContainer } from '../shareSunrise';
import { SignatureStatsVictoryContainer } from '../stats/signatureStatsSunrise';

export function SideVictoryContainer(): JSX.Element {
	const {
		data: {
			petition: { isVerifiedVictory },
		},
	} = usePetitionDetailsPageData();

	return (
		<div className="flex flex-col gap-6">
			<div className="bg-gradient-background-dark-1 rounded-medium p-2">
				<div className="text-typography-inverse-strong flex flex-row items-center justify-center gap-1">
					<VictoryIcon />
					<Text as="h3" variant="heading" size="small">
						{isVerifiedVictory ? (
							<Translate value="fe.pages.petition_show.status.confirmed_victory" />
						) : (
							<Translate value="fe.pages.petition_show.status.victory" />
						)}
					</Text>
				</div>
			</div>
			<SignatureStatsVictoryContainer textAlign="left" />
			<h2 className="sr-only">
				<Translate value="fe.components.petition_share.action" />
			</h2>
			<ShareContainer forMobileView={false} />
		</div>
	);
}
